export enum Domain {
  Insite = 'insite',
  Pinroutes = 'pinroutes'
}
